import { lazy } from 'react';
import type { RouteObject } from 'react-router';
import { RequireAuth } from '@/routes/guards';

// Páginas carregadas sob demanda (cada uma vira um pedaço separado do bundle)
const FinanceHome = lazy(() => import('./pages/Home'));
const ContractsPage = lazy(() => import('./pages/Contracts'));
const PayoutsPage = lazy(() => import('./pages/Payouts'));
const InvoicesPage = lazy(() => import('./pages/Invoices'));
const RefundsPage = lazy(() => import('./pages/Refunds'));
const ReconciliationPage = lazy(() => import('./pages/Reconciliation'));
const ApprovalsPage = lazy(() => import('./pages/Approvals'));

const finance = (el: React.ReactNode) => <RequireAuth roles={['FINANCE']}>{el}</RequireAuth>;

/** Perfil financeiro (T-46..T-50) + aprovação de saques do gestor (RN-36). */
const routes: RouteObject[] = [
  { path: '/financeiro', element: <RequireAuth roles={['FINANCE', 'MANAGER']}><FinanceHome /></RequireAuth> },
  { path: '/financeiro/contratos', element: finance(<ContractsPage />) },
  { path: '/financeiro/repasses', element: finance(<PayoutsPage />) },
  { path: '/financeiro/notas', element: finance(<InvoicesPage />) },
  { path: '/financeiro/reembolsos', element: finance(<RefundsPage />) },
  { path: '/financeiro/extratos', element: finance(<ReconciliationPage />) },
  { path: '/financeiro/aprovacoes', element: <RequireAuth roles={['MANAGER']}><ApprovalsPage /></RequireAuth> },
];
export default routes;
